import { getPieceFilterMapping } from "../../features/createSecondaryOrder/CreateSecondaryOrderService";
import "./CatalogueFilters.css";

interface CatalogueFiltersPropTypes {
  filterOptions: Record<string, string[]>;
  selectedFilters: Record<string, string>;
  updateFilterSelection: (filterType: string, option: string) => void;
}

const CatalogueFilters: React.FC<CatalogueFiltersPropTypes> = ({
  filterOptions,
  selectedFilters,
  updateFilterSelection,
}) => {
  const filterOrder = ["category", "pieceSize", "brand"];

  const checkFilterAppliedForType = (type: string) => {
    return type in selectedFilters && selectedFilters[type] !== "ALL";
  };

  const checkFilterAppliedForOption = (type: string, option: string) => {
    return type in selectedFilters && selectedFilters[type] === option;
  };

  const totalFilterTypes = Object.keys(filterOptions).length;

  return (
    <div className="catalogueFiltersWrapper" style={{height: `${37*totalFilterTypes}px`}}>
      <div className="catalogue-filters-container">
        {filterOrder.map((type) => {
          const filters = filterOptions[type];
          if (!filters) return null;
          return (
            <div className="catalogue-filters-row">
              <div
                className={`option-box ${!checkFilterAppliedForType(type) && "active-filter"}`}
                onClick={() => updateFilterSelection(type, "ALL")}
              >
                All
              </div>
              <div className="filter-type-container" key={type}>
                {filters?.map((option: any) => {
                  return (
                    <div
                      className={`option-box ${
                        checkFilterAppliedForOption(type, option) && "active-filter"
                      }`}
                      key={option}
                      onClick={() => updateFilterSelection(type, option)}
                    >
                      {type === "pieceSize" ? getPieceFilterMapping(option) : option}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CatalogueFilters;
